import { Link } from "react-router-dom";

export default function NotFoundPage() {
	return (<h1>Page Not Found, go to <Link to="/">Home</Link></h1>);
}
